module.exports = __webpack_public_path__ + "img/success1.9f52457c.png";